<template>
  <div>
    <!-- START STEP 1-->
    <section class="pedido-steps" v-if="!form_success">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link :to="route">
                <img :src="require('@/assets/img/backspace.svg')" alt="backspace" class="mb-5">
              </router-link>
            </div>
            <div class="section-title">
              <h4>Creación de Zona</h4>
              <router-link :to="route + 'zona-listado'">
                <img class="d-none d-sm-block" :src="require('@/assets/img/backspace.svg')" alt="backspace">
              </router-link>
            </div>
            <p class="subtitulo">En esta sección puede crear una nueva zona</p>
          </div>
        </div>
        <form method="GET" id="form-id">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" id="sku">
                <label>SKU
                  <Tooltip :parent="'sku'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <VueMultiselect
                    v-model="data.sku"
                    :options="skuOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :loading="loadingSKU"
                    :disabled="loading"
                    placeholder="Select one"
                    label="displayText"
                />
                <span class="required-span" v-if="!data.sku && errors?.sku">{{ errors.sku }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" id="start_date">
                <label>Fecha de Inicio
                  <Tooltip :parent="'start_date'" :message="'Fecha de inicio de la zona.'">?</Tooltip>
                </label>
                <Datepicker
                    v-model="data.start_date"
                    name="start-date"
                    :enableTimePicker="false"
                    :disabled="loading"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                />
                <span class="required-span" v-if="!data.start_date && errors?.start_date">{{ errors.start_date }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" id="final_date">
                <label>Fecha Final
                  <Tooltip :parent="'final_date'" :message="'Fecha final.'">?</Tooltip>
                </label>
                <Datepicker
                    v-model="data.final_date"
                    name="final-date"
                    :enableTimePicker="false"
                    :disabled="loading"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                />
                <span class="required-span" v-if="!data.final_date && errors?.final_date">{{ errors.final_date }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" id="zone">
                <label>Zona
                  <Tooltip :parent="'zone'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <VueMultiselect
                    v-model="data.zone"
                    :options="zoneOptions"
                    :disabled="loading"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :loading="loadingZone"
                    placeholder="Select one"
                    label="displayText"
                />
                <span class="required-span" v-if="!data.zone && errors?.zone">{{ errors.zone }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" id="_quantity">
                <label>Cantidad
                  <Tooltip :parent="'quantity'" :message="'Cantidad de sku máximo permitidos para la compra.'">?
                  </Tooltip>
                </label>
                <input type="number" id="quantity" name="quantity" v-model="data.quantity" :min="0" :disabled="loading">
                <span class="required-span" v-if="!data.quantity && errors?.quantity">La cantidad es obligatoria.</span>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12 next-btn d-none d-md-block">
            <input type="button" class="btn-green" value="Guardar" @click="submitForm()" :disabled="loading">
            <input type="button" class="btn-white" value="Cancelar" @click="cancelCuota()" :disabled="loading">
          </div>
          <!-- Botones para dispositivos pequeños -->
          <div class="col-12 next-btn d-block d-md-none mb-3">
            <input type="button" class="btn-green" style="margin-right: auto; margin-left: auto;"
                   value="Guardar" @click="submitForm()" :disabled="loading">
          </div>
          <div class="col-12 next-btn d-block d-md-none mb-3">
            <input type="button" class="btn-white" style="margin-right: auto; margin-left: auto;"
                   value="Cancelar" @click="cancelCuota()" :disabled="loading">
          </div>

          <div class="loading" v-if="loading"></div>
        </div>
      </div>
    </section>

    <ZonaCreated
        v-if="form_success"
        :message="'La zona se creó correctamente!'"
        :parent="'zona-listado'"
    ></ZonaCreated>

  </div>
  <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert"/>
</template>

<script>
import {route} from "@/enviroment";
import axios from "axios";
import Tooltip from "../../snippets/Tooltip.vue";
import ZonaCreated from "@/components/snippets/ZonaCreated";

export default {
  name: 'ZonaNueva',
  data: function () {
    return {
      route: route,
      data: {
        sku: '',
        start_date: '',
        final_date: '',
        zone: '',
        quantity: ''
      },
      errors: [],
      loadingSKU: false,
      skuOptions: [],
      loadingZone: false,
      zoneOptions: [],
      loading: false,
      form_success: false,
      alertVisible: false
    }
  },
  components: {
    ZonaCreated,
    Tooltip
  },
  created() {
    this.getSkus();
    this.getZones();
  },
  methods: {
    getSkus() {
      this.loadingSKU = true;
      axios.get('cuotificador/available/skus')
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.skuOptions = data.skus.map((sku) => ({
              value: sku.code, // Valor a usar en el v-model
              displayText: `${sku.code} - ${sku.name} - ${sku.material}`, // Texto visible en el VueMultiselect
            }));
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.skuOptions = [];
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => this.loadingSKU = false);
    },
    getZones() {
      this.loadingZone = true;
      this.data.zone = '';
      axios.post(
          'cuotificador/available/zones',
          {},
      ).then(async (res) => {
        if (res.status === 200 && res.data.status === 'success') return res.data.data;
        else throw new Error(res.data.message);
      }).then(async (data) => {
        if (data.status.toString() === 'error') throw new Error(data.message);
        this.zoneOptions = data.zones.map((zone) => ({
          value: zone.zona_nombre, // Valor a usar en el v-model
          displayText: `${zone.zona_nombre}`, // Texto visible en el VueMultiselect
        }));
      }).catch((error) => {
        let msg = '';
        if (error.status && error.status === 200) msg = error.message;
        else msg = error;
        this.zoneOptions = [];
        this.showAlert('warning', 'Atención!', msg);
      }).finally(() => this.loadingZone = false);
    },
    validForm() {
      this.errors = [];
      if (!this.data.sku || !this.data.sku.value) this.errors['sku'] = 'El SKU es obligatorio.';
      if (!this.data.start_date) this.errors['start_date'] = 'La fecha de inicio es obligatorio.';
      if (!this.data.final_date) this.errors['final_date'] = 'La fecha final es obligatorio.';
      if (!this.data.zone || !this.data.zone.value) this.errors['zone'] = 'La zona es obligatoria.';
      if (this.data.quantity === '') this.errors['quantity'] = 'La cantidad es obligatoria.';
      return Object.keys(this.errors).length === 0;
    },
    submitForm() {
      if (!this.validForm()) return;
      this.loading = true;
      const dataCloned = JSON.parse(JSON.stringify(this.data));
      const sku = dataCloned.sku.displayText.split(' - ');
      dataCloned.ean = sku[0];
      dataCloned.sku = sku[2];
      dataCloned.start_date = dataCloned.start_date.substring(0, 10);
      dataCloned.final_date = dataCloned.final_date.substring(0, 10);
      dataCloned.zone = dataCloned.zone.value;
      // eslint-disable-next-line
      axios.post('/cuotificador/zones', Object.fromEntries(Object.entries(dataCloned).filter(([v]) => v)))
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.errors = [];
            this.form_success = true;
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.alertVisible = true;
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => {
            this.loading = false;
          });
    },
    async cancelConfirm() {
      return await this.$vbsModal.confirm({
        title: "Cancelar Zona",
        message: "Está seguro que desea cancelar la zona?",
        leftBtnText: 'No',
        rightBtnText: 'Si',
        displayCloseBtn: false
      });
    },
    async cancelCuota() {
      const confirmed = await this.cancelConfirm();
      if (!confirmed) {
        return;
      }
      location.href = route + 'zona-listado';
    },
    showAlert(type, title, message) {
      if (this.alertVisible) {
        this.$refs.alert.showAlert(
            type,
            message,
            title,
            {
              iconSize: 35,
              iconType: 'solid',
              position: 'top right',
            }
        );
        this.$refs.alert.$el.style.display = 'block';
        this.hideAlert();
      }
    },
    hideAlert() {
      setTimeout(() => {
        this.$refs.alert.$el.style.display = 'none';
        this.alertVisible = false
      }, 5000);  // 5 segundos y se borra
    },
  }
}
</script>